// @flow
import { PATH } from '../config/constants';

import { matchPath } from 'react-router-dom';

export const PAGE_TYPES: {
  HOME: 'home',
  VIEWER: 'viewer',
  REPORTER: 'reporter',
  TEMPORARY_REPORT: 'temporary-report',
  WORKLIST: 'worklist',
  URT: 'urt',
  PRODUCTPORTAL: 'productportal',
  LOGIN: 'login',
  UNKNOWN: 'unknown',
} = Object.freeze({
  HOME: 'home',
  VIEWER: 'viewer',
  REPORTER: 'reporter',
  TEMPORARY_REPORT: 'temporary-report',
  WORKLIST: 'worklist',
  URT: 'urt',
  PRODUCTPORTAL: 'productportal',
  LOGIN: 'login',
  UNKNOWN: 'unknown',
});
export type PageTypes = $Values<typeof PAGE_TYPES>;

export function getPathName(str: string): string {
  try {
    return new URL(str).pathname;
  } catch (err) {
    return str;
  }
}

export function getPageType(url: string): PageTypes {
  const pathname = getPathName(url);

  if (matchPath(PATH.HOME, pathname)) {
    return PAGE_TYPES.HOME;
  } else if (matchPath(PATH.VIEWER, pathname)) {
    return PAGE_TYPES.VIEWER;
  } else if (matchPath(PATH.REPORTER, pathname)) {
    return PAGE_TYPES.REPORTER;
  } else if (matchPath(PATH.TEMPORARY_REPORT, pathname)) {
    return PAGE_TYPES.TEMPORARY_REPORT;
  } else if (matchPath(PATH.WORKLIST, pathname)) {
    return PAGE_TYPES.WORKLIST;
  } else if (matchPath(PATH.URT, pathname)) {
    return PAGE_TYPES.URT;
  } else if (matchPath(PATH.PRODUCTPORTAL, pathname)) {
    return PAGE_TYPES.PRODUCTPORTAL;
  } else if (matchPath(PATH.LOGIN, pathname)) {
    return PAGE_TYPES.LOGIN;
  } else {
    return PAGE_TYPES.UNKNOWN;
  }
}
